<template>
  <PhoneTasksListView v-if="showPhoneList" />
  <TasksView v-else-if="showDesktopList" assignee-me />
</template>

<script setup>
import { computed, getCurrentInstance, onMounted, ref } from "vue";
import { LD_FLAG_IDEA_MDP_650 } from "@components/constants/launchDarklyFlagKeys";
import PhoneTasksListView from "@/views/PhoneTasks/PhoneTasksListView.vue";
import TasksView from "./TasksView.vue";

const { proxy } = getCurrentInstance() || {};

const phoneFlagEnabled = ref(false);
const flagResolved = ref(false);

const isPhoneViewport = computed(() => proxy?.$vuetify?.breakpoint?.xsOnly === true);
const showPhoneList = computed(
  () => isPhoneViewport.value && flagResolved.value && phoneFlagEnabled.value
);
const showDesktopList = computed(
  () => !isPhoneViewport.value || (flagResolved.value && !phoneFlagEnabled.value)
);

onMounted(async () => {
  try {
    phoneFlagEnabled.value =
      typeof proxy?.$getFlag === "function"
        ? (await proxy.$getFlag(LD_FLAG_IDEA_MDP_650, false)) === true
        : false;
  } catch {
    phoneFlagEnabled.value = false;
  }
  flagResolved.value = true;
});
</script>
